<template>

<div>
    
    <div class="jumbotron page-header d-flex justify-content-center align-items-center">
        <div class="inner-page-header text-center pb-5">
            <span class="icon icon-house"></span>
            <h1>Преглед на проект</h1>
            <div class="breadcrumbs">
                <breadcrumbs></breadcrumbs>
            </div>
        </div>
    </div>

    <div class="main-page-content">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="page-header-info shadow-lg p-4 mb-lg-5 text-center">
                        След като сте попълнили цялата информация и сте прикачили необходимите файлове, администратор на Видеа ще разгледа проекта и ще се свърже с Вас.
                    </div>
                </div>

            </div>

            <project-form :pid='$route.params.id'></project-form>
    
            <project-files :pid='$route.params.id'></project-files>

        </div>
    </div>

    
</div>

</template>

<script>
    export default {

        mounted() {
        
            this.setBcLinks([ 
                { name : 'Моите проекти', url : 'my-projects' },
                { name : 'Преглед на проект', url : '' } 
            ]);
        
        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

        }

    }
</script>
